export const UPDATE_NEW_CAMPAIGN = 'UPDATE_NEW_CAMPAIGN';
export const CREATE_NEW_CAMPAIGN_REQUEST = 'CREATE_NEW_CAMPAIGN_REQUEST';
export const CREATE_NEW_CAMPAIGN_SUCCESS = 'CREATE_NEW_CAMPAIGN_SUCCESS';
export const CREATE_NEW_CAMPAIGN_FAILURE = 'CREATE_NEW_CAMPAIGN_FAILURE';



// WEBPACK FOOTER //
// ./src/redux/constants/newCampaign.js